(function () {
	'use strict';

	angular.module('mx.components').directive('mxZoom', mxZoom);

	mxZoom.$inject = ['$mdDialog'];

	function mxZoom($mdDialog) {
		return {
			link: link,
		};

		function link(scope, element, attrs) {
			element.on('click', onClick);
			scope.$on('$destroy', cleanUp);

			function onClick() {
				$mdDialog.show({
					clickOutsideToClose: true,
					controllerAs: 'vm',
					controller: [
						'$mdDialog',
						function ($mdDialog) {
							var vm = this;
							vm.url = attrs.src;

							vm.cancel = function () {
								$mdDialog.cancel();
							};
						},
					],
					template: [
						'<div layout="column" layout-align="end" class="mx-zoom__dialog">',
						'<img src="{{vm.url}}">',
						'<md-button class="md-accent md-raised md-hue-2" ng-click="vm.cancel()">Close</md-button>',
						'</div>',
					].join(''),
				});
			}

			function cleanUp() {
				element.off('click', onClick);
			}
		}
	}
})();
